import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'evaluationLegacyValueLabel',
    standalone: false,
})
export class EvaluationLegacyValueLabelPipe implements PipeTransform {
    public transform(value: number, target: number | null): string {
        const safeTarget = target ?? 0;
        const percentage = safeTarget === 0 ? 0 : (value / safeTarget) * 100;
        return `${percentage}% (${value})`;
    }
}
